import api from "@/api/axios";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    SET_LIST(state, payload) {
      state.list = payload;
    },
  },
  actions: {
    async fetchList({ commit }, params = {}) {
      try {
        commit("setLoading", true, { root: true });
        const res = await api.get("/admin/delivery-slot-exceptions", {
          params: { all: 1, ...params },
        });
        const data = res.data.data || res.data;
        commit("SET_LIST", Array.isArray(data) ? data : []);
        return data;
      } catch (error) {
        commit("setLoading", false, { root: true });
        throw error;
      } finally {
        commit("setLoading", false, { root: true });
      }
    },
    async create({ dispatch }, payload) {
      const res = await api.post("/admin/delivery-slot-exceptions", payload);
      await dispatch("fetchList");
      return res.data;
    },
    async update({ dispatch }, { id, ...payload }) {
      await api.put(`/admin/delivery-slot-exceptions/${id}`, payload);
      await dispatch("fetchList");
    },
    async delete({ dispatch }, id) {
      await api.delete(`/admin/delivery-slot-exceptions/${id}`);
      await dispatch("fetchList");
    },
  },
  getters: {
    list: (state) => state.list,
  },
};
